import { render } from "./AddOrEditEventFormOptions.vue?vue&type=template&id=a3b8cdc6&ts=true"
import script from "./AddOrEditEventFormOptions.vue?vue&type=script&lang=ts"
export * from "./AddOrEditEventFormOptions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__